import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
const getSelectionValue = (element, contextProperties) => {
  var _context;
  let selection = element.getAttribute('data-trackable-selection') || _trimInstanceProperty(_context = element.textContent).call(_context);
  const namespace = element.getAttribute('data-trackable-group') || contextProperties.group;
  if (namespace) {
    selection = `${namespace} > ${selection}`;
  }
  return selection.toLowerCase();
};
export default getSelectionValue;